import { PREFIX_POPULAR_ITEMS_LIFETIME } from "@/config/series";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class GetPrefixPopularItems extends Vue {
  intervalID = 0;

  // Use in created()
  getPrefixPopularItems(prefixID: number) {
    this.$store.dispatch("debugMode/fetchPrefixPopularItems", prefixID);

    // Refetch data periodically
    this.intervalID = setInterval(() => {
      this.$store.dispatch("debugMode/fetchPrefixPopularItems", prefixID);
    }, PREFIX_POPULAR_ITEMS_LIFETIME);
  }

  // Use in beforeDestroy()
  cleanUpPrefixPopularItems() {
    clearInterval(this.intervalID);
  }
}
